import AuthorizedRoute from 'Components/AuthorizedRoute';
import { SITE_PAGES } from 'Config';
import withRouter from 'Lib/hoc/withRouter';
import { Route, Routes } from 'react-router';
import ManageUsersView from '../ManageUsersView';
import UserDetailsPage from './UserDetailsPage';

let UserDetailWithRouter = withRouter(UserDetailsPage);

const Users = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.MANAGE_USERS.requiredAuth}>
            <ManageUsersView />
          </AuthorizedRoute>
        }
      />
      <Route
        path='/:id'
        element={
          <AuthorizedRoute requiredAuth={SITE_PAGES.MANAGE_USERS.requiredAuth}>
            <UserDetailWithRouter />
          </AuthorizedRoute>
        }
      />
    </Routes>
  );
};

let Page = withRouter(Users);
export default Page;
